module.exports = __webpack_public_path__ + "img/house.09cf8919.jpeg";